"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
var reducer_1 = require("./reducer");
var utils_1 = require("./utils");
function generateAsyncReducer(name, asyncMethod) {
    var initialState = {
        data: null,
        error: null,
        loading: false,
        params: null
    };
    // Create reducer
    var reducer = new reducer_1["default"](name, initialState);
    // Add get data action
    var get = reducer.addAsyncAction("get" + utils_1.capitalize(name), asyncMethod, {
        start: function (state, action) {
            return {
                data: null,
                error: null,
                loading: true,
                params: null
            };
        },
        error: function (state, action) {
            return __assign({}, state, { error: action.error, loading: false, params: action.params });
        },
        success: function (state, action) {
            return __assign({}, state, { data: action.data, loading: false, params: action.params });
        }
    });
    var reset = reducer.addAction("reset" + utils_1.capitalize(name), function () { return initialState; });
    return {
        get: get,
        reset: reset,
        reducer: reducer
    };
}
exports["default"] = generateAsyncReducer;
;
